interface TextInputBaseProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
}

export const TextInputBase = ({ value, onChange, placeholder, error}: TextInputBaseProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      e.currentTarget.blur();
    }
  };

  return (
    <div className="input-field-container">
      {/* Background container */}
      <div className="input-background" />

      {/* Profile icon */}
      <div className="input-icon">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="13" cy="8.5" r="3.5" stroke="#ADB4C0" strokeWidth="1.5" fill="none" />
          <path
            d="M6.5 19.5C6.5 16.5 9.5 14 13 14C16.5 14 19.5 16.5 19.5 19.5"
            stroke="#ADB4C0"
            strokeWidth="1.5"
            fill="none"
          />
        </svg>
      </div>

      {/* Input field */}
      <input
        type="text"
        value={value}
        placeholder={placeholder ?? ''}
        className={`input-field ${error ? 'input-field-error' : ''}`}
        onChange={(e) => handleChange(e)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};